import RootRoutes from "./RootRoutes";
export default RootRoutes;